class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.wrap = this.querySelector('.faq-answer-wrap');
    if (!this.details || !this.summary || !this.wrap) return;

    this.animating = null;

    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.animating) this.animating.cancel();
      this.details.open ? this.close() : this.open();
    });
  }

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  open() {
    this.details.open = true;
    if (this.prefersReducedMotion()) return;
    const h = this.wrap.scrollHeight;
    this.animating = this.wrap.animate(
      [
        { height: '0px', overflow: 'hidden' },
        { height: h + 'px', overflow: 'hidden' },
      ],
      { duration: 300, easing: 'ease-out' },
    );
    this.animating.onfinish = () => (this.animating = null);
  }

  close() {
    if (this.prefersReducedMotion()) {
      this.details.open = false;
      return;
    }
    const h = this.wrap.scrollHeight;
    this.animating = this.wrap.animate(
      [
        { height: h + 'px', overflow: 'hidden' },
        { height: '0px', overflow: 'hidden' },
      ],
      { duration: 300, easing: 'ease-out' },
    );
    this.animating.onfinish = () => {
      this.details.open = false;
      this.animating = null;
    };
  }
}

customElements.define('faq-accordion', FaqAccordion);
